export default {
    isReady: isDomReady,
    execMethodsOnReady,
    addToQueueIfNotReady,
    unwrap,
    appendHtml,
    closestParent
};

function isDomReady() {
    return document.readyState === "complete";
}

function execMethodsOnReady(domReadyCallbacks) {
    document.onreadystatechange = function () {
        if (document.readyState == "complete") {
            domReadyCallbacks.forEach(callback => callback());
        }
    };
}

function addToQueueIfNotReady(method, queue) {
    return (args, success, error) => {
        if (isDomReady()) {
            method(args, success, error);
        } else {
            queue.addMethod(method, args, success, error);
        }
    };
}

// Function to unwrap client side elements
function unwrap(element) {
    var fragment = document.createDocumentFragment();
    while (element.firstChild) {
        var child = element.removeChild(element.firstChild);
        fragment.appendChild(child);
    }

    element.parentNode.replaceChild(fragment, element);
}

// Function to append HTML to an element
function appendHtml(element, html) {
    var div = document.createElement("div");
    div.innerHTML = html;

    while (div.children.length > 0) {
        element.appendChild(div.children[0]);
    }
}

// Function to get the closest parent that matches a selector
function closestParent(element, selector, stopSelector) {
    var result = null;
    while (element) {
        if (element.matches(selector)) {
            result = element;
            break;
        } else if (stopSelector && element.matches(stopSelector)) {
            break;
        }

        element = element.parentNode;
    }

    return result;
}


// WEBPACK FOOTER //
// ./src/js/utils/DomHelper.js